import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const ProfileChartsDataContext = createContext();

const ProfileChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.PROFILE_PEOPLE,
            url: 'governanceroom/dashboard/unifiedregistry/people/profile'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              ageGroup: data?.ageGroup
                  ? [...data.ageGroup.sort((a, b) => b.total - a.total)]
                  : [],
              cityOfBirth: data?.cityOfBirth ?? [],
              ethnicity: data?.ethnicity ?? [],
              gender: data?.gender ?? [],
              placeOfBirthType: data?.placeOfBirthType ?? [],
              stateOfBirth: data?.stateOfBirth ?? []
          }
        : {
              ageGroup: [],
              cityOfBirth: [],
              ethnicity: [],
              gender: [],
              placeOfBirthType: [],
              stateOfBirth: []
          };

    return (
        <ProfileChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ProfileChartsDataContext.Provider>
    );
};

export default ProfileChartsDataProvider;
